import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiKeyboardTab = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M12 18L10.575 16.6L14.175 13H2V11H14.175L10.6 7.4L12 6L18 12L12 18ZM20 18V6H22V18H20Z" />
  </SvgWrapper>
);
